import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { PaymentMethodService } from './payment-service.service';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.css'],
})
export class PaymentMethodComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = [
    'SNo',
    'payment_method',
    'createdAt',
    'updatedAt',
    'status',
    'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any[] = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public selectedId: number | null = null;
  paymentMethod: FormGroup;
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

  constructor(
    private paymentMethodService: PaymentMethodService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.paymentMethod = this.fb.group({
      status: ['', Validators.required],
      payment_method: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.getPaymentMethods();
  }

  getPaymentMethods() {
    this.isLoading.next(true);
    this.paymentMethodService.getPaymentMethods().subscribe(
      (response) => {
        this.ELEMENT_DATA = response.body.data;
        this.dataSource.data = this.ELEMENT_DATA;
        this.isLoading.next(false);
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  onSubmit() {
    this.submitted = true;

    if (this.paymentMethod.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit) {
      if (this.selectedId !== null) {
        this.paymentMethodService
          .updatePaymentMethod(this.selectedId, this.paymentMethod.value)
          .subscribe(
            (response) => {
              let responseData = response.body;
              if (responseData.responseCode == 200) {
              this.toastr.success('Payment Method updated successfully');
              this.clearForm();
              this.isEdit = false;
              this.getPaymentMethods();
              this.isLoading.next(false);
              } else {
                this.isLoading.next(false);
                this.toastr.error(responseData.responseMessage)
              }
            },
            (error) => {
              this.toastr.error('Error updating Payment Method');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      this.paymentMethodService
        .createPaymentMethod(this.paymentMethod.value)
        .subscribe(
          (response) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
            this.toastr.success('Payment Method created successfully');
            this.clearForm();
            this.isCreate = false;
            this.getPaymentMethods();
            this.isLoading.next(false);
            }else {
              this.isLoading.next(false);
              this.toastr.error(responseData.responseMessage)
            }
          },
          (error) => {
            this.toastr.error('Error creating Payment Method');
            this.isLoading.next(false);
          }
        );
    }
  }

  edit(element: any) {
    this.isEdit = true;
    this.isCreate = false;
    this.selectedId = element.id;
    this.paymentMethod.patchValue({
      status: element.status ? 1 : 0,
      payment_method: element.payment_method,
    });
  }

  clearForm() {
    this.submitted = false;
    this.paymentMethod.patchValue({
      status: '',
      payment_method: '',
    });
    this.selectedId = null;
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.getPaymentMethods();
  }
}
